// Shared validation rules used by BOTH the client-side forms and the Netlify Edge Function.
// Keep in sync with /frontend/netlify/edge-functions/form-validator.js

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Common junk patterns bots and lazy users fill in
const JUNK_RE = /^(test|asdf|qwerty|abcd|1234|aaaa|nnnn|xxxx|zzzz|blank|none|na|n\/a)$/i;
const URL_RE = /https?:\/\/|www\.|\.(com|net|org|ru|cn|xyz|shop|top|info)\b/i;
const REPEAT_RE = /^(.)\1+$/;                 // "aaaaa"
const LETTERS_RE = /[a-zA-Z]/;                // must contain at least one letter

export const isValidEmail = (v) => EMAIL_RE.test(String(v || '').trim());

export const isValidPhone = (v) => {
  const digits = (String(v || '').match(/\d/g) || []).length;
  return digits >= 7 && digits <= 15;         // 7 to 15 digits (US + intl)
};

// Reject junk names: too short, no letters, all same char, common bot fillers, URLs
export const validateName = (v, label = 'Name') => {
  const s = String(v || '').trim();
  if (s.length < 2) return `${label} must be at least 2 characters.`;
  if (s.length > 60) return `${label} is too long.`;
  if (!LETTERS_RE.test(s)) return `${label} must contain letters.`;
  if (REPEAT_RE.test(s)) return `${label} looks invalid.`;
  if (JUNK_RE.test(s)) return `${label} looks invalid — please enter your real name.`;
  if (URL_RE.test(s)) return `${label} cannot contain a link or URL.`;
  return null;
};

export const validateEmail = (v) => {
  const s = String(v || '').trim();
  if (!s) return 'Email is required.';
  if (!EMAIL_RE.test(s)) return 'Please enter a valid email address.';
  if (URL_RE.test(s.split('@')[0])) return 'Please enter a valid email address.';
  return null;
};

export const validatePhone = (v) => {
  const s = String(v || '').trim();
  if (!s) return 'Phone number is required.';
  if (!isValidPhone(s)) return 'Please enter a valid phone number.';
  return null;
};

// Real message: at least 5 chars, at least 2 words, contains letters, not just gibberish
export const validateMessage = (v, min = 5) => {
  const s = String(v || '').trim();
  if (s.length < min) return `Message must be at least ${min} characters.`;
  if (s.length > 3000) return 'Message is too long.';
  if (!LETTERS_RE.test(s)) return 'Message must contain letters.';
  if (REPEAT_RE.test(s)) return 'Message looks invalid.';
  const words = s.split(/\s+/).filter((w) => w.length > 0);
  if (words.length < 2) return 'Please write at least a couple of words.';
  const urls = (s.match(/https?:\/\//gi) || []).length;
  if (urls > 2) return 'Message cannot contain multiple URLs.';
  return null;
};

// Cross-field rule: reject if too many fields have identical content (bot signal)
export const isSuspiciousDuplicate = (values) => {
  const trimmed = values.map((v) => String(v || '').trim().toLowerCase()).filter(Boolean);
  if (trimmed.length < 2) return false;
  const unique = new Set(trimmed);
  return unique.size === 1;
};
